<app-selector
  label="Maze Game"
  [isEmptySelectable]="isEmptySelectable"
  [data]="mazeGameCoreService.mazeGameList$ | async"
  displayKey="name"
  [formControl]="ctrl"
  (refreshEvent)="refresh()"
  hintStyle="margin-left: -14px; margin-top: -5px"
  [loading]="mazeGameCoreService.loading$ | async"
  [hint]="hint"
>
</app-selector>
